import script from "./ListLoadingPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListLoadingPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./ListLoadingPlaceholder.vue?vue&type=style&index=0&id=1e091f2b&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e091f2b"]])

export default __exports__